import React, { useEffect, useRef, useState } from "react";
import { db } from "../db/firestore";
import { Modal_Loading, Modal_Success } from "../modal";
import { colors, initialMember } from "../configs";
import { formatTime, getRandomUppercaseLetter } from "../Utility/function";
import { Table } from "react-bootstrap";
import { NumberYMD } from "../Utility/dateTime";
import ExcelJS from "exceljs";
import { OneButton } from "../components";
import * as XLSX from 'xlsx';
import firebase from 'firebase/app';
import { useDispatch, useSelector } from "react-redux";
import { fetchMember } from "../redux/memberSlice";

const { white } = colors;


function UploadMemberScreen() {
    const dispatch = useDispatch();
    const { shop:{ shopId, vip } } = useSelector(state=>state.shop);
    const { members:currentMembers, modal_Member  } = useSelector(state=>state.member);
    const [loading, setLoading] = useState(false);
    const [success_Modal, setSuccess_Modal] = useState(false);

    const [members, setMembers] = useState([]);


    useEffect(()=>{
        dispatch(fetchMember(shopId))
    },[]);



    const handleFileUpload = async (event) => {
        const file = event.target.files[0];

        if (file) {
        const reader = new FileReader();
        reader.onload = async (e) => {
            const arrayBuffer = e.target.result;
            const workbook = new ExcelJS.Workbook();

            await workbook.xlsx.load(arrayBuffer);
            const worksheet = workbook.getWorksheet(1);

            const extractedMembers = [];
            worksheet.eachRow((row, rowNumber) => {
            if (rowNumber > 1) { // Skip header
                extractedMembers.push({
                    name: row.getCell(1).value||'', // Assuming name in column A
                    tel: row.getCell(2).value||'', // Assuming name in column A
                    point: row.getCell(3).value||'', // Assuming name in column A
                    credit: row.getCell(4).value||'', // Assuming name in column A
                });
            }
            });

            setMembers(extractedMembers); // Now update the state
          

        };

        reader.readAsArrayBuffer(file);
        }
    };

    async function addMemberToFirebase() {
        if (members.length === 0) {
            return alert('กรุณาอัปโหลดไฟล์');
        };
        const IsVipMember = vip.some(a=>a.type === 'member' && NumberYMD(formatTime(a.expire)) >= NumberYMD(new Date()) );
        const totalMember  = currentMembers.length + members.length;
        if(totalMember > 50 && !IsVipMember){
            return alert('คุณสามารถมีสมาชิกได้สูงสุด 50 คน')
        } 
        if(totalMember >2000){
            return alert('คุณสามารถมีสมาชิกได้สูงสุด 2000 คน')
        }
    
        try {
            setLoading(true);
    
            const BATCH_LIMIT = 500;
            const memberChunks = [];
    
            // Split products into chunks of 500
            for (let i = 0; i < members.length; i += BATCH_LIMIT) {
                memberChunks.push(members.slice(i, i + BATCH_LIMIT));
            }
            const letter = 'A'+getRandomUppercaseLetter();

            const memberWithIds = [];
            
            // Process each chunk sequentially
            for (const chunk of memberChunks) {
                const batch = db.batch();
                chunk.forEach(({ name, tel, credit, point }) => {
                    const newItem = {
                        ...initialMember,
                        name,
                        tel,
                        shopId,
                        point:Number(point),
                        credit:Number(credit),
                        timestamp:firebase.firestore.FieldValue.serverTimestamp(),
                        letter
                    };
    
               
                    const newDocRef = db.collection('member').doc();
                    batch.set(newDocRef, newItem);
                    memberWithIds.push({ id: newDocRef.id, name, tel })
                });
    
                await batch.commit(); // commit each batch
            };
            const memberListKey = letter+ shopId;
            await db.collection('memberList').doc(memberListKey).set({
                members: memberWithIds,
                shopId,
                updateTime:new Date()
            });
            console.log('All batch writes successful');
    
            setMembers([]);
            setSuccess_Modal(true);
            setTimeout(() => setSuccess_Modal(false), 900);
        } catch (error) {
            console.error('Error adding products:', error);
        } finally {
            setLoading(false);
        }
    }
    const fileInputRef = useRef(null);
    const triggerFileUpload = () => {
        // Trigger the hidden file input when the button is clicked
        fileInputRef.current.click();
    };

    const exportToExcel = () => {
        // Create a worksheet from your table data
        const worksheetData = [];
    
        // Create headers
        const headers = ['ชื่อ','เบอร์โทร','จำนวนแต้ม','ยอดเงินเซ็น'];
        worksheetData.push(headers);
    
    
        // Create a new workbook and add the worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
    
        // Use sanitized sheet name
        const sheetName = 'แม่แบบสำหรับอัปโหลดสมาชิก'
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    
        // Export the workbook to a file
        XLSX.writeFile(workbook, `แม่แบบสำหรับอัปโหลดสมาชิกช็อปแชมป์.xlsx`);
      };

  return (
    <div style={{  height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor:white, width:'100vw' }}>
        <Modal_Loading show={loading || modal_Member} />
        <Modal_Success show={success_Modal} />
        <h1>อัปโหลดสมาชิกผ่านไฟล์</h1>
        <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileUpload}
            ref={fileInputRef}
            style={{ display: "none" }} // Hide the input field
        />
        <div style={{ display:'flex', margin:10 }} >
            <OneButton {...{ text:'1.ดาวน์โหลดไฟล์แม่แบบ', submit:exportToExcel, variant:'dark' }} />&emsp;
            <OneButton {...{ text:'2.อัปโหลดไฟล์', submit:triggerFileUpload, variant:'warning' }} />&emsp;
            <OneButton {...{ text:'3.อัปโหลดสมาชิก', submit:addMemberToFirebase, variant:'success' }} />

        </div>
        <Table striped bordered hover responsive  variant="light"   >
            <thead  >
                <tr>
                    <th style={styles.text2}>No.</th>
                    <th style={styles.text}>ชื่อ</th>
                    <th style={styles.text}>เบอร์โทร</th>
                    <th style={styles.text}>จำนวนแต้ม</th>
                    <th style={styles.text}>ยอดเงินเซ็น</th>
                </tr>
            </thead>
        <tbody  >
            {members.map((item, index) => {
                const { name, tel, credit, point } = item;
                return <tr  key={index} >
                            <td style={styles.text3}>{index+1}.</td>
                            <td style={styles.text3} >{name}</td>
                            <td style={styles.text3} >{tel}</td>
                            <td style={styles.text3}>{point}</td>
                            <td style={styles.text3}>{credit}</td>
                        </tr>
            })}
        </tbody>
        </Table>
        <br/>
   
    </div>
  );
};

const styles = {
    text : {
        width:'15%', minWidth:'150px', textAlign:'center'
    },
    text2 : {
        width:'10%', minWidth:'50px'
    },
    text3 : {
        textAlign:'center'
    }
}

export default UploadMemberScreen;